import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"
import Layout from '../../../components/Layout/Layout'
import Therapist from "../../../components/Therapist/Therapist"

// markup

const name = 'Jeanne Bunkers'
const license = 'MSW, CSW-PIP'
const areas = [
    'Anxiety',
    'Depression',
    'Grief and Loss',
    'ADD/ADHD',
    'Trauma',
    'Life Transitions and Adjustments',
]

const IndexPage = () =>
(
    <Layout full={true} removeTopSpace={true} className="bg-yellow-50">
        <Therapist
            name={name}
            license={license}
            areas={areas}
            photo={(<StaticImage src='./jeanne.jpeg' alt={name} layout="constrained" className="shadow" />)}
        >

        <p>Jeanne is a Certified Social Worker in Private Independent Practice with more than 20 years of experience helping adolescents and adults navigate life’s challenges with compassion, understanding, and practical support. Her career began working with teens in residential treatment centers, supporting families through foster care licensing programs, and providing counseling in community mental health settings. Since opening her private practice in 2002, she has remained dedicated to creating a warm, supportive space where clients feel heard, respected, and encouraged.</p>
        <p>Jeanne works with adolescents and adults experiencing anxiety, depression, ADHD, grief and loss, and major life transitions. Her approach is grounded in empathy, connection, and helping clients make meaningful, lasting changes.</p>
        <p>Jeanne accepts most insurances including Medicare and Medicaid.</p>
        </Therapist>
    </Layout>
)

export default IndexPage
